import mixins from '@synergycms_core/less/mixins.js';

export default {
    promoContainer: {},
    promoCodeIcon: {},
    promoCodeBox: {},
    inputPromo: {},
    insertCode: {},
    submitButtonContainer: {},
    promoCodeButton: {},
    correctCodeButton: {},
    rightCode: {},
    insertCodeIcon:{},
    dropDownContainer:{},
    applyButtonContainer:{},
    applyButton:{},
    codeText:{},
    removeRoom:{},
    removeCode:{},
    DESK :{},
    MOBIL:{},
    TABLET:{},
    dispoModal:{},
    engineFileContainer:{},
    promoWiMode:{},
    //insideButtonSpan:{},
    portalDesign:{},
    engineMerged:{},
    roundedTheme:{},
    defaultStyle: data => ({
      marginBottom: 0,
      position: 'relative',
      color: '#fff',
      backgroundColor:'transparent',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        width: '12.5%',
        verticalAlign: 'middle',
        maxWidth:'116px',
        background: 'none',
        display: 'table-cell',
        '&$roundedTheme':{
          width: '15%',
        }
      },
      '&:lang(ar)': {
        [`@media (min-width: ${data.modalBreak}px)`]: {
          borderRight: 'none',
        }
      },
      '&$engineFileContainer':{
        [`@media (min-width: ${data.modalBreak}px)`]: {
          //width:'20.5%',
          width:'15.5%',
        }
      },
      '&$promoWiMode':{
        [`@media (min-width: ${data.modalBreak}px)`]: {
          width:'15.5%',
        }
      },
      '&$portalDesign':{
        '&:not($dispoModal)':{
          maxWidth:'143px',
          '& $promoContainer':{
            [`@media (min-width: ${data.modalBreak}px)`]:{
              height:'80px',
              '&:lang(ar)':{
                '& button': {
                  paddingRight: '5px',
                  '& > span':{
                    display: 'flex',
                    textAlign: 'right',
                    justifyContent: 'center',
                    '& > span':{
                      marginLeft: '5px',
                      marginRight: '0',
                    }
                  }
                }
              },
            }
          },
        },
        '& $promoContainer':{
          '& $insideButton':{
            fontSize:'15px',
            letterSpacing:'0.54px',
            [`@media (min-width: ${data.modalBreak}px)`]:{
              height:'80px',
              paddingLeft:'14px',
              color:'#4a4a4a',
            },
            '& $insertCodeIcon':{
              [`@media (min-width: ${data.modalBreak}px)`]:{
                fontSize:'18px',
                lineHeight:'19px',
                position:'static',
                marginRight:'5px',
              },
            }
          },
        },
        '&$engineMerged':{
          '& $removeCode':{
            top: '50%',
            left: '80%',
          },
          '@media (min-width: 1024px) and (max-width:1200px)':{
            maxWidth: '50px',
            '& $promoContainer':{
              '& $insideButton':{
                padding: 'unset',
                '& $insideButtonSpan':{
                  textAlign: 'center',
                  '& $insertCodeIcon':{
                    fontSize: '24px',
                    lineHeight: '24px',
                    margin: 'unset'
                  }
                }
              },
              '& $codeApliedContainer':{
                '& $removeCode':{
                  top: '90%',
                  left: '40%',
                }
              }
            },
          }
        },
      },
      '& $promoContainer':{
        [`@media (min-width: ${data.modalBreak}px)`]: {
          backgroundColor:'#fff',
          position:'relative',
          height:'49px'
        },
      },
      '& $codeApliedContainer':{
        [`@media (min-width: ${data.modalBreak}px)`]:{
          display:'flex',
          alignItems:'self-start',
          justifyContent:'center',
          flexDirection:'column'
        },
      },
      '& $animationContainer':{
        '&:before':{
          top:'-6px',
        },
        '&:lang(ar)':{
          '&:before':{
            left: '67%',
          }
        },
        [`@media (min-width: ${data.modalBreak}px)`]: {
          filter:'drop-shadow(0px 2px 5px rgba(0,0,0,50%))'
        }
      },
      '& $animationContent':{
        [`@media (min-width: ${data.modalBreak}px)`]: {
          boxShadow:'none',
        }
      },
      '&$roundedTheme':{
        paddingRight: '10px',
        '& $promoContainer':{
          borderRadius: '0 25px 25px 0',
          '& $insertCodeIcon':{
              fontSize:'18px',
          }
        }
      }
    }),
    outsideButton: data => ({
      color: '#fff',
      font: '13px ' + data.fontFamily1,
      position:'relative',
      paddingLeft:'35px',
      maxWidth:'148px',
      display:'block',
      cursor:'pointer',
      textAlign:'left',
      '& $insertCodeIcon':{
        position:'absolute',
        color: data.mainColor,
        top:'50%',
        left:'0',
        fontSize:'22px',
        lineHeight:0,
        '&:lang(ar)':{
          left: 'auto',
          right: '0',
        },
        [`@media (min-width: ${data.modalBreak}px)`]: {
          left:'12px',
          '&:lang(ar)': {
            right: '12px!important',
            left: 'auto!important',
          }
        },
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        font: '13px ' + data.fontFamily1,
        paddingLeft:'41px',
        paddingRight:'5px',
        color: '#000',
        textTransform:'initial',
      },
      
    }),
    insideButton: data => ({
      composes : '$outsideButton',
      maxWidth: 'none',
      width:'100%',
      height:'40px',
      textAlign:'left',
      font: '300 13px ' + data.fontFamily1,
      '&:after':{
        content: `''`,
        width:0,
        height:0,
        borderLeft:'5px solid transparent',
        borderRight:'5px solid transparent',
        borderTop: '5px solid ' + data.mainColor,
        top:'50%',
        right:0,
        marginTop:'-2px',
        position:'absolute',
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        height:'49px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp:2,
        WebkitBoxOrient:'vertical',
        '&:after':{
          content:'none'
        },
        '&:lang(ar)': {
          paddingLeft: '5px',
          paddingRight: '41px',
        }
      },
      '&:lang(ar)': {
        textAlign: 'right',
        paddingLeft: '5px',
        paddingRight: '41px',
        '&:after':{
          right: 'auto',
          left: '0'
        }
      }
    }),
    insideButtonSpan: data => ({
      [`@media (min-width: ${data.modalBreak}px)`]: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp:2,
        WebkitBoxOrient:'vertical',
        '&:lang(ar)': {
          textAlign: 'right',
        }
      }
    }),
    iconsEngine: data => ({
      position: 'absolute',
      fontSize: '22px',
      lineHeight: '40px',
      left: '12px',
      top: 0,
      color: data.mainColor,
      [`@media (min-width: ${data.modalBreak}px)`]: {
        lineHeight: '50px'
      },
      '&:lang(ar)': {
        left: 'auto',
        right: '12px'
      }
    }),
    codeAppliedText: data => ({
      color:'#b2b2b2',
      display:'block',
      marginTop:'5px',
      font: '12px ' + data.fontFamily1,
      textOverflow:'ellipsis',
      whiteSpace:'nowrap',
      overflow:'hidden',
      width: '100%',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        font: '10px ' + data.fontFamily1,
      }
    }),
    codeApliedContainer: data => ({
      height:'100%',
      textAlign:'left',
      position:'relative',
      padding:'12px 20px 10px 47px',
      ...mixins.boxSizing(),
      '&:lang(ar)':{
        padding: '12px 47px 10px 20px',
        textAlign: 'right',
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        paddingLeft:'14px',
        padding: '0 5px',
        width:'100%',
        '&:lang(ar)': {
          textAlign: 'right',
          padding: '12px 20px 10px 14px',
        }
      },
      '& $insertCode':{
      font: '14px ' + data.fontFamily1,
        color:'#fff',
        display:'block',
        [`@media (min-width: ${data.modalBreak}px)`]: {
          color:'#000',
          font: '300 13px ' + data.fontFamily1,
          textOverflow:'ellipsis',
          whiteSpace:'nowrap',
          overflow:'hidden',
          width: '80%',
        }
      },
      '& $removeCode':{
        color: data.mainColor,
        fontWeight:'bold',
        position:'absolute',
        right:'12px',
        margin:0,
        fontSize:'10px',
        top:'50%',
        marginTop:'-15px',
        width:'15px',
        height:'15px',
        zIndex:'10',
        [`@media (min-width: ${data.modalBreak}px)`]: {
          right:'15px',
          '&:lang(ar)': {
            right: 'auto!important',
            left: '10px!important',
          }
        },
        '&:lang(ar)':{
          right: 'auto',
          left: '-9px',
        }
      },
      '& $iconsEngine':{
        top:'7px'
      }
    }),
    animationContainer: data => ({
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before': {
          left: '38%',
          marginLeft: '30px',
          marginBottom: 0,
          borderBottom: '6px solid #fff',
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          content: `''`,
          position: 'absolute',
          top:'4px'
        },
        '&:lang(ar)': {
          '&:before':{
            left: '61.5%'
          }
        }
      }
    }),
    animationContent: data => ({
      [`@media (min-width: ${data.modalBreak}px)`]: {
        boxShadow: '0 3px 4px 0 rgba(0,0,0,.3)',
        position:'relative',
        backgroundColor:'#fff',
        padding:'15px 10px',
        ...mixins.boxSizing()
      }
    }),
    inputEnter: {
      transition: 'max-height 0ms ease-out',
      maxHeight: '0',
      transitionDelay: '.3s',
      marginBottom: 0
    },
    inputEnterActive: {
      maxHeight: '100px',
      transition: 'max-height 300ms ease-out,margin-bottom .3s ease-out',
      overflow: 'hidden',
      transitionDelay: '.3s',
      marginBottom: '10px'
    },
    inputLeave: {
      maxHeight: '100px',
      transition: 'max-height 300ms ease-out',
      overflow: 'hidden'
    },
    inputLeaveActive: {
      transition: 'max-height 0 ease-out',
      marginBottom: '0',
      maxHeight: '0'
    },
};